import { AnyAction, configureStore, PreloadedState, ThunkAction } from '@reduxjs/toolkit'

import contextSubscriber from './contextSubscriber'
import * as persistence from './persistence'
import rootReducer from './reducers'
import requestLimitMiddleware from './requestLimitMiddleware'
import requestMiddleware from './requestMiddleware'

export function setupStore(preloadedState?: PreloadedState<RootState>) {
  const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        // https://redux-toolkit.js.org/api/immutabilityMiddleware
        immutableCheck: false,
        // https://redux-toolkit.js.org/api/serializabilityMiddleware
        serializableCheck: false
      }).concat(requestMiddleware, requestLimitMiddleware, persistence.middleware),
    preloadedState,
    enhancers: defaultEnhancers => [persistence.enhancer, ...defaultEnhancers]
  })

  store.subscribe(contextSubscriber(store))

  return store
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, AnyAction>
